import LenderActivity from './LenderSettingsActivity';

export default LenderActivity;
